export default __webpack_public_path__ + "static/media/Wyn_Shotglasses.37ed896b.jpg";